import { connect } from "react-redux";
import { compose } from "redux";
import { selectIsDevicesLoaded } from "../../redux/assets/assetsSelectors";
import { createStructuredSelector } from "reselect";

import WithSpinner from "../../components/withSpinner/withSpinner.component";
import MainView from "./views/MainView";

const mapStateToProps = createStructuredSelector({
  isLoading: (state) => !selectIsDevicesLoaded(state),
});

const MainContainer = compose(
  connect(mapStateToProps),
  WithSpinner
)(MainView);

export default MainContainer; 